import React, { useEffect, useState } from "react";
import { db } from "../database/firebase";
import { collection, deleteDoc, doc, onSnapshot } from "firebase/firestore";
import Swal from "sweetalert2";

const ListaClasesRealtime = () => {
  const [clasesRealtime, setClasesRealtime] = useState([]);
  const [busqueda, setBusqueda] = useState("");

  const handleDelete = async (id) => {
    const claseRealtimeDoc = doc(
      db,
      "contenidoClases",
      "claseRealtimeDoc",
      "claseRealtime",
      id
    );
    Swal.fire({
      title: "¿Estas seguro?",
      text: "¡No podrás revertir esto!",
      icon: "warning",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await deleteDoc(claseRealtimeDoc);
      }
    });
  };

  useEffect(() => {
    const fetchClases = () => {
      const claseRealtimeDoc = doc(db, "contenidoClases", "claseRealtimeDoc");
      const claseRealtimeCollection = collection(
        claseRealtimeDoc,
        "claseRealtime"
      );
      onSnapshot(claseRealtimeCollection, (snapshot) => {
        const newClaseRealtimeData = snapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
          fecha: doc.data().fecha.toDate().toLocaleString(),
          timestamp: doc.data().timestamp,
        })).sort((a, b) => b.timestamp - a.timestamp);
        setClasesRealtime(newClaseRealtimeData);
      });
    };

    fetchClases();
  }, []);

  console.log("clasesRealtime", clasesRealtime);

  return (
    <div class="flex flex-col flex-grow w-full">
      {clasesRealtime.length === 0 ? (
        <p class="text-white text-center font-bold text-[30px] leading-[48px] mt-[50px]">
          Todavía no agregaste clases 1 a 1
        </p>
      ) : (
        <input
          class="bg-gray-700 border-1 border-white/20 text-white p-2 m-2 rounded shadow mx-[50px]"
          type="text"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          placeholder="Buscar por nombre"
        />
      )}
      <div class="max-h-[150px] overflow-y-auto scrollbar scrollbar-thumb-rounded-full scrollbar-thumb-[#4a8ded] scrollbar-track-[#444b5d] scrollbar-track-rounded">
        {clasesRealtime
          .filter((clase) =>
            clase.titulo.toLowerCase().includes(busqueda.toLowerCase())
          )
          .slice()
          .reverse()
          .map((clase) => (
            <div
              class="border border-1 border-white/20 p-2 m-2 rounded shadow"
              key={clase.id}
            >
              <div class="text-white flex items-center w-full justify-between">
                <button
                  class="bg-red-600 rounded hover:bg-red-800 text-white font-bold py-2 px-3 mr-2 shadow-btn-shadow shadow-red-600/25 transition-all duration-300"
                  onClick={() => handleDelete(clase.id)}
                >
                  <svg
                    className="w-6 h-6 text-gray-800 dark:text-white"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="#fff"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                    />
                  </svg>
                </button>
                <div class="flex justify-between w-full mx-2 items-center">
                  <span class="text-[20px] leading-[25px] max-w-[280px] break-words">
                    {clase.titulo}
                  </span>
                  <span class="font-bold text-[20px] leading-[48px]">
                    {clase.fecha}
                  </span>
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ListaClasesRealtime;
